const CloverApiVersion = Object.freeze({
    REST_PAY_DISPLAY: 'rest-pay-display',
    PLATFORM: 'platform',
});

module.exports = CloverApiVersion;
